// extracted by mini-css-extract-plugin
export default {"toolbarPadder":"M_yARfSq3Rmk0MKDpSFJ","padder":"A9Unjtc9wpC1sbeHDTY4","contentWidth":"glLhFE9tMwEGmLi5a3Fi","notice":"ZZSetQhrcgHNEZA48Rxf","mail":"QoGiknBjpddYm6FBiAAT"};